import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';

const PackageForm = () => {
  
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    short_desc: '',
    features: [],
    expiry_type: '',
    expiry_time: '',
    price: '',
    is_free_trial: false,
    free_trial_days: '',
  });

  const [newFeature, setNewFeature] = useState('');

  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);
 

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `packages/${id}`,
      });
      const data = response.data;
      if (data.status) {
        setFormData(data.data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const addFeature = () => {
    if (newFeature.trim()) {
      setFormData(prev => ({
        ...prev,
        features: [...prev.features, newFeature.trim()]
      }));
      setNewFeature('');
    }
  };

  const removeFeature = (index) => {
    setFormData(prev => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === 'features') {
          data.append(key, JSON.stringify(formData[key]));
        } else {
          data.append(key, formData[key]);
        }
      });

      const response = await ApiService.request({
        method: 'POST',
        url: `packages/createOrUpdate/${id || ''}`,
        data,
      });

      if (response.data.status) {
        toast.success(response.data.message);
        navigate('/packages');
      } else {
        toast.error(response.data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Form submission failed:', error);
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit' : 'Add New'} Package
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/packages" className="text-muted text-hover-primary">Packages</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-0">
              <form onSubmit={handleSubmit} className="form fv-plugins-bootstrap5 fv-plugins-framework">
                <div className="row g-9 my-3">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Title</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Package Title"
                      required
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Price</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control form-control-solid"
                      placeholder="Enter Package Price"
                      required
                      name="price"
                      value={formData.price}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-12 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2">Short Description</label>
                    <textarea
                      className="form-control form-control-solid"
                      placeholder="Enter Package Description"
                      name="short_desc"
                      value={formData.short_desc}
                      onChange={handleChange}
                      rows="3"
                    />
                  </div>

                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Expiry Type</label>
                    <select
                      className="form-control form-select"
                      name="expiry_type"
                      value={formData.expiry_type}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Expiry Type</option>
                      <option value="Days">Days</option>
                      <option value="Months">Months</option>
                      <option value="Years">Years</option>
                    </select>
                  </div>

                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Expiry Time</label>
                    <input
                      type="number"
                      className="form-control form-control-solid"
                      placeholder="Enter Expiry Time"
                      required
                      name="expiry_time"
                      value={formData.expiry_time}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="is_free_trial"
                        checked={formData.is_free_trial}
                        onChange={handleChange}
                      />
                      <label className="form-check-label fs-6 fw-semibold">
                        Free Trial Available
                      </label>
                    </div>
                  </div>

                  {formData.is_free_trial && (
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">Free Trial Days</label>
                      <input
                        type="number"
                        className="form-control form-control-solid"
                        placeholder="Enter Free Trial Days"
                        required
                        name="free_trial_days"
                        value={formData.free_trial_days}
                        onChange={handleChange}
                      />
                    </div>
                  )}

                  <div className="col-md-12 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2">Features</label>
                    <div className="d-flex gap-2 mb-3">
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Feature"
                        value={newFeature}
                        onChange={(e) => setNewFeature(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addFeature())}
                      />
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addFeature}
                      >
                        Add
                      </button>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                      {formData.features.map((feature, index) => (
                        <span key={index} className="badge badge-light-primary d-flex align-items-center gap-2">
                          {feature}
                          <button
                            type="button"
                            className="btn btn-sm btn-icon btn-light-danger"
                            onClick={() => removeFeature(index)}
                          >
                            <i className="bi bi-x"></i>
                          </button>
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="row g-9 my-3">
                  <div className="text-center">
                    <Link to={`/packages`} className="btn btn-light me-3">Back</Link>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      <span className="indicator-label">{isLoader ? <Loader size="20" color="white" text="Submitting" /> : ('submit')}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageForm;
